import {ModalManager} from "@soinproduction/kit";

document.addEventListener('DOMContentLoaded', () => {
    window.modalManager = new ModalManager({
        activeMode: "active-mode",
        fadeInTimeout: 300,
        fadeOutTimeout: 300,
        closeOnEsc: true,
        closeOnOverlayClick: true
    });
});

